import { useState, useEffect } from "react";

const navItems = ["About", "Products", "Features", "Contact"];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
      style={{ height: 80 }}
    >
      <div className="w-full h-full flex items-center justify-between px-6 md:px-12">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/e9fcafd3-bf85-4c95-b4ca-0c9e01920a48.png"
            alt="FORMO d.o.o. logo"
            className="h-10 w-auto object-contain"
          />
          <span
            className={`font-semibold text-lg tracking-tight transition-colors duration-300 ${
              scrolled ? "text-gray-900" : "text-white"
            }`}
          >
            FORMO d.o.o.
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item)}
              className={`text-sm font-medium transition-all duration-200 hover:opacity-70 cursor-pointer whitespace-nowrap ${
                scrolled ? "text-gray-700" : "text-white/90"
              }`}
            >
              {item}
            </button>
          ))}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className={`block w-6 h-0.5 transition-all duration-300 ${
                scrolled ? "bg-gray-800" : "bg-white"
              }`}
            />
          ))}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item)}
              className="text-sm font-medium text-gray-700 text-left cursor-pointer whitespace-nowrap hover:text-gray-900"
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
